import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { GET_USER_GUIDE_PROGRESS } from "shared/UserGuides/gql";

const useAssistantPanelLearnActiveGuide = () => {
  const { data, loading } = useQuery(GET_USER_GUIDE_PROGRESS);

  const activeGuide = data?.activeUserGuideProgress?.guide;
  const currentStepIndex = data?.activeUserGuideProgress?.currentStep ?? 1;

  const steps = activeGuide?.steps;
  const totalSteps = steps?.length ?? 0;

  const currentStep = useMemo(() => {
    if (!steps) return undefined;
    return steps.find((s) => s.order === currentStepIndex);
  }, [steps, currentStepIndex]);

  const completedGuideIds = useMemo(() => {
    return data?.completedUserGuides?.map((g) => g.guide.id) ?? [];
  }, [data?.completedUserGuides]);

  const nextGuideId = activeGuide?.completion.recommendedGuideIds[0];
  const isNextGuideCompleted = nextGuideId ? completedGuideIds.includes(nextGuideId) : false;

  return {
    activeGuide,
    currentStep,
    currentStepIndex,
    totalSteps,
    loading,
    nextGuideId,
    isNextGuideCompleted,
  };
};

export default useAssistantPanelLearnActiveGuide;
